import "core-js/modules/es.array.concat.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-134a4b50"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  class: "logo"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "headerSpace"
};
var _hoisted_5 = {
  class: "header-space-right-menu"
};
var _hoisted_6 = {
  class: "logout-block__label"
};
var _hoisted_7 = {
  key: 1,
  class: "lang-separator"
};
var _hoisted_8 = {
  class: "lang-dropdown"
};
var _hoisted_9 = {
  class: "selected-item-container"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_w_icon = _resolveComponent("w-icon");
  var _component_router_link = _resolveComponent("router-link");
  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  var _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isAuth() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "menuContainer",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.toggleMenu && _ctx.toggleMenu.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_w_icon, {
    icon: _ctx.isMenuVisible ? 'backburger' : 'menu',
    size: "20px",
    class: "iconMenu"
  }, null, 8, ["icon"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: "/",
    class: "logo__link"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("img", {
        src: _ctx.logoPath
      }, null, 8, _hoisted_3)];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.isAuth() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "logout-block",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.logoutUser();
    })
  }, [_createVNode(_component_w_icon, {
    icon: "logout",
    class: "logout-block__picto"
  }), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('header.logout_label')), 1)])) : _createCommentVNode("", true), _ctx.isAuth() ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_dropdown, {
    placement: "bottom",
    size: "small",
    trigger: "click",
    onCommand: _ctx.onLangChanges
  }, {
    dropdown: _withCtx(function () {
      return [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languagesDropdownItems, function (item) {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: item.key,
              command: item.key
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("span", null, [_createElementVNode("div", {
                  class: _normalizeClass("icon-language ".concat(item.icon))
                }, null, 2)])];
              }),
              _: 2
            }, 1032, ["command"]);
          }), 128))];
        }),
        _: 1
      })];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languagesDropdownItems, function (item) {
        return _openBlock(), _createElementBlock("span", null, [_createElementVNode("div", {
          class: _normalizeClass("icon-language ".concat(!item.isSelected ? 'icon-language--hide' : '', " ").concat(item.icon))
        }, null, 2)]);
      }), 256))])];
    }),
    _: 1
  }, 8, ["onCommand"])])])]), _hoisted_10]);
}